module.exports = __webpack_public_path__ + "img/Envoye_Special_logo.35db451d.svg";